// extracted by mini-css-extract-plugin
export default {"loading":"Content_loading__Dbx1o"};